import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { payment } from './payment';
import { touch } from './touch';
import { media } from './media';
import { chatdesk } from './chatdesk';
import { richLink } from './richLink';
import { timePicker } from './timePicker';
import { Auth } from './oAuth';
import { location } from './location';
import { iMessage } from './iMessage';
import { displayMenu } from './displayText';
import { DynamicLayout } from '../../formbuilder';
import { chat2pay } from './chat2pay';
import { multipleChoice } from './multipleChoice';
import { dynamicList } from './dynamicList';
import {menuForm} from './menuForm';
import {contactReceiving} from "./contactReceiving";
import {contactSending} from "./contactSending";

const optionSeperator = '. ';

const menuOption = {
  json: {
    menu: {
      menuType: 'menuOption',
      menuHeader: '',
      imageRef: '',
      bodyText: '',
      menuParams: {
        groupTitle: '',
        displayType: '',
        displayTypes: {},
        customListButton: '',
      },
      options: {
        optionSeperator,
        items: {
          1: {
            imageRef: '',
            bodyText: '',
            text: '',
            next: newStepValue,
          },
        },
        keywords: {
          1: [],
        },
      },
      results: {
        default: {
          next: "OPTIONAL"
        }
      }
    },
    type: 'menu',
    next: '_MENU_END_',
    metadata: {},
  },
  paths: [
    'menu.imageRef',
    'menu.menuParams.displayTypes',
    'menu.menuParams.customListButton',
    'menu.menuHeader',
    'menu.menuParams.groupTitle',
    'menu.bodyText',
    'menu.options.optionSeperator',
    'menu.options.items.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.imageRef',
        'menu.menuParams.displayTypes',
        'menu.menuHeader',
        'menu.menuParams.groupTitle',
        'menu.bodyText',
        'menu.options.optionSeperator'
      ],
    },
    {
      Logic: [ 'menu.results.default','menu.options.items.#'],
    },
  ],
  layout: {
    menuHeader: {
      type: 'input',
      label: 'Menu Header',
      placeholder: 'Name the menu header',
      attributes: {
        optional: true
      }
    },
    imageRef: {
      type: 'image',
      label: '',
      validators: {
        required: false,
      },
    },
    bodyText: {
      type: 'textarea',
      label: 'Body Text',
      text: 'description',
      placeholder: 'Enter a body text',
      attributes: {
        required: true
      },
      validators: {
        required: true,
      },
    },
    groupTitle: {
      type: 'input',
      label: 'Sub Header',
      placeholder: 'Add a subheader',
      validators: {
        required: false,
      },
      attributes: {
        optional: true
      }
    },
     description: {
      type: 'input',
      label: '$',
      text: 'description',
      placeholder: 'Add description / subtext',
      validators: {
        required: false,
      },
      attributes: {
        optional: true
      }
    },
    optionSeperator: {
      type: 'autocomplete',
      label: 'Option Separator',
      validators: {
        optionSelected: true,
      },
      attributes: {
        options: [optionSeperator],
        optional: true,
      },
    },
    items: {
      dataType: 'item',
      attributes: {
        add: true,
        delete: true,
      },
    },
    text: {
      type: 'text',
      label: '$',
      text: 'option',
      placeholder: 'Add option text',
      validators: {
        required: true,
      },
    },
    keywords: {
      dataType: 'keyword',
      type: 'chips',
      label: '',
      placeholder: 'Add keyword(s)',
      validators: {
        maxLength: 5,
        duplicate: true,
      },
    },
    flowId: {
      type: 'next',
      label: 'Point to',
    },
    next: {
      type: 'next',
      label: 'Point to',
    },
    default: {
      type: 'default',
      label: 'Default',
      attributes: {
        optional: true
      }
    },
    displayTypes: {
      type: 'button',
      label: 'Channel Display Type (Default)',
      attributes: {
        options: {
          button: 'Reply Buttons',
          list: 'List Message',
          number: 'Numbered List',
          auto: 'Auto Select'
        },
        warning: true
      }
    },
  },
  data: {
    items: {
      imageRef: '',
      text: '',
      bodyText: '',
      next: newStepValue,
    },
    keywords: [],
  },
};

const askInput = {
  json: {
    menu: {
      text: '',
      input: {
        isPrivateVariable: false,
        validationPattern: '',
        varName: '',
      },
      cancel: {
        cancelInput: '',
        cancelMessage: '',
      },
      menuType: 'askInput',
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.text',
    'menu.input.isPrivateVariable',
    'menu.input.varName',
    'menu.input.validationPattern',
    'menu.cancel.cancelInput',
    'menu.cancel.cancelMessage',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.text',
        'menu.input.isPrivateVariable',
        'menu.input.varName',
        'menu.input.validationPattern',
        'menu.cancel.cancelInput',
        'menu.cancel.cancelMessage',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
  layout: {
    text: {
      type: 'textarea',
      label: 'Menu Text',
      validators: {
        required: true,
      },
    },
    isPrivateVariable: {
      type: 'checkbox-single',
      label: 'Sensitive',
    },
    varName: {
      type: 'text',
      label: 'Variable Name',
      validators: {
        required: true,
      },
    },
    validationPattern: {
      type: 'text',
      label: 'Validation Pattern',
    },
    cancelInput: {
      type: 'text',
      label: 'Cancel Input',
    },
    cancelMessage: {
      type: 'text',
      label: 'Cancel Message',
    },
    next: {
      type: 'next',
      label: 'Point to',
      validators: {
        optionSelected: true,
      },
    },
  },
};

const externalLink = {
  json: {
    menu: {
      menuType: 'externalLink',
      text: '',
      url: '',
      results: {
        other: {
          next: newStepValue,
          description: 'ERROR',
        },
      },
    },
    type: 'menu',
    metadata: {}
  },
  paths: ['menu.text', 'menu.url', 'menu.results.#'],
  groups: [
    {
      Parameters: ['menu.text', 'menu.url'],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
  layout: {
    text: {
      type: 'textarea',
      label: 'Text',
    },
    url: {
      type: 'text',
      label: 'URL',
      validators: {
        required: true,
      },
    },
    results: {
      dataType: 'keyObject',
      attributes: {
        // readonly: true
        add: true,
        delete: true,
      },
      key: {
        type: 'text',
        label: '#',
        validators: {
          required: true,
        },
      },
      value: {
        description: {
          type: 'text',
          label: 'Description',
          validators: {
            required: true,
          },
        },
        next: {
          type: 'next',
          label: 'Point to',
        },
      },
    },
  },
  data: {
    results: {
      next: newStepValue,
      description: '',
    },
  },
};

const otpMenu = {
  json: {
    menu: {
      menuType: 'otp',
      text: '',
      otp: {
        retries: 3,
        resends: 2,
        otpLength: 4,
        otpTimetolive: 0,
        resendInputs: [],
        otpMessageText: '',
        resendLimitReachedMessage: '',
        retryText: '',
        resendText: '',
      },
      results: {
        success: {
          next: newStepValue,
          description: 'success',
        },
        failure: {
          next: newStepValue,
          description: 'failure',
        },
        error: {
          next: newStepValue,
          description: 'Error',
        },
      },
    },
    metadata: {},
    type: 'menu',
  },
  paths: [
    'menu.text',
    'menu.otp.retries',
    'menu.otp.resends',
    'menu.otp.otpLength',
    'menu.otp.otpTimetolive',
    'menu.otp.resendInputs',
    'menu.otp.otpMessageText',
    'menu.otp.resendLimitReachedMessage',
    'menu.otp.retryText',
    'menu.otp.resendText',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.text',
        'menu.otp.retries',
        'menu.otp.resends',
        'menu.otp.otpLength',
        'menu.otp.otpTimetolive',
        'menu.otp.resendInputs',
        'menu.otp.otpMessageText',
        'menu.otp.resendLimitReachedMessage',
        'menu.otp.retryText',
        'menu.otp.resendText',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
  layout: {
    text: {
      type: 'textarea',
      label: 'Menu Header',
      validators: {
        required: true,
      },
    },
    retries: {
      type: 'number',
      label: 'Retries',
      validators: {
        required: true,
        hasNegativeNumber: true,
        minimumCount: 1,
      },
    },
    otpTimetolive: {
      type: 'number',
      label: 'Time Out',
      validators: {
        required: true,
        hasNegativeNumber: true,
      },
    },
    resends: {
      type: 'number',
      label: 'Resends',
      validators: {
        required: true,
        hasNegativeNumber: true,
        minimumCount: 1,
      },
    },
    otpLength: {
      type: 'number',
      label: 'Otp Length',
      validators: {
        required: true,
        hasNegativeNumber: true,
        minimumCount: 4,
      },
    },
    resendInputs: {
      dataType: 'array',
      type: 'chips',
      label: 'Resend Inputs',
      placeholder: '',
      validators: {
        maxLength: 5,
        duplicate: true,
      },
    },
    otpMessageText: {
      type: 'text',
      label: 'Otp Message Text',
      validators: {
        required: true,
      },
    },
    resendLimitReachedMessage: {
      type: 'text',
      label: 'Resend Limit Reached Message',
      validators: {
        required: true,
      },
    },
    retryText: {
      type: 'text',
      label: 'Retry Text To Prepend',
      validators: {
        required: true,
      },
    },
    resendText: {
      type: 'text',
      label: 'Resend Text To Prepend',
      validators: {
        required: true,
      },
    },
    results: {
      dataType: 'keyObject',
      key: {
        type: 'text',
        label: '#',
        attributes: {
          readonly: true,
        },
        validators: {
          required: true,
        },
      },
      value: {
        description: {
          type: 'text',
          label: 'Description',
          validators: {
            required: true,
          },
        },
        next: {
          type: 'next',
          label: 'Point to',
        },
      },
    },
  },
  data: {
    results: {
      next: newStepValue,
      description: '',
    },
  },
};

export const orca_payment: DynamicLayout = {
  json: {
    menu: {
      name: '',
      menuType: 'orca_payment',
      menuHeader: '',
      imageRef: '',
      menuParams: {
        currencyCode: 'USD',
        countryCode: 'US',
        merchantInfo: {
          capabilities: ['supports3DS', 'supportsDebit', 'supportsCredit'],
          supportedNetworks: ['amex', 'visa', 'discover', 'masterCard'],
        },
        lineItems: {
          '': {
            label: '',
            amount: '',
          },
        },
      },
      results: {
        PAYMENT_COMPLETED: {
          description: 'Payment Succeeds',
          next: newStepValue,
        },
        PAYMENT_DECLINED: {
          description: 'Payment Failed',
          next: newStepValue,
        },
        UNKNOWN: {
          description: 'Payment Unknown',
          next: newStepValue,
        },
      },
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.imageRef',
    'menu.name',
    'menu.menuHeader',
    'menu.menuParams.lineItems.#',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: ['menu.imageRef', 'menu.name', 'menu.menuHeader', 'menu.menuParams.lineItems.#'],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
  layout: {
    menuHeader: {
      type: 'text',
      label: 'Title',
      validators: {
        required: true,
      },
    },
    name: {
      type: 'text',
      label: 'name',
    },
    imageRef: {
      type: 'image',
      label: '',
    },
    lineItems: {
      dataType: 'keyObject',
      key: {
        type: 'text',
        label: 'item name',
        validators: {
          required: true,
        },
      },
      value: {
        label: {
          type: 'text',
          label: 'Description',
          validators: {
            required: true,
          },
        },
        amount: {
          type: 'text',
          label: 'amount',
          validators: {
            required: true,
          },
        },
      },
    },
    results: {
      dataType: 'keyObject',
      key: {
        type: 'text',
        label: '#',
        attributes: {
          readonly: true,
        },
        validators: {
          required: true,
        },
      },
      value: {
        description: {
          type: 'text',
          label: 'Description',
          attributes: {
            readonly: true,
          },
        },
        next: {
          type: 'next',
          label: 'Point to',
        },
      },
    },
  },
  data: {
    lineItems: {
      label: '',
      amount: '',
    },
    results: {
      next: newStepValue,
      description: '',
    },
  },
};

export const multiProduct = {
  json: {
      menu: {
        menuType: "multiProduct",
        bodyText: "",
        menuHeader: "",
        menuParams: {
          subHeader: "",
          buttonText: "",
          isDynamic: false,
          productIds: ""
        }
      },
      next: newStepValue,
      type: "menu"
  }
}

export const menuTypes = {
  menuOption: menuOption,
  askInput: askInput,
  displayMenu: displayMenu,
  externalLink: externalLink,
  multipleChoice: multipleChoice,
  dynamicList: dynamicList,
  payment: payment,
  touch: touch,
  media: media,
  chatdesk: chatdesk,
  otp: otpMenu,
  richLink: richLink,
  timePicker: timePicker,
  location: location,
  orca_payment: orca_payment,
  authenticate: Auth,
  iMessage: iMessage,
  chat2pay: chat2pay,
  multiProduct: multiProduct,
  menuForm: menuForm,
  contactReceiving: contactReceiving,
  contactSending: contactSending,
};
